import "../scss/style.scss"
"use strict";
import "./accordion"
import "./top"
import "./swiper"
import "./vivus"
import "./scroll"
import "./parallax"
import "./modal"

let vw = window.innerWidth;

if (window.ontouchstart === null) {
  document.body.classList.add('is-touch');
}

window.addEventListener("DOMContentLoaded", () => {
  appHeight();
  anchorLink();

  document.body.classList.add('is-dom-loaded')

  const scrollable = document.querySelector('.js-scrollable');
  if (scrollable) {
    scrollable.addEventListener('touchmove', handleScroll);
    scrollable.addEventListener('scroll', handleScroll);
  }
});

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
    return;
  }
  vw = window.innerWidth;
  appHeight();
});

function appHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function anchorLink() {
  const anchorLink = document.querySelectorAll('.js-anchorLink');
  anchorLink.forEach(el => {
    el.addEventListener('click', event => {
      event.preventDefault();
      let hash = el.hash;
      let targetElement = document.getElementById(hash.replace('#', ''));
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const gap = ( document.body.classList.contains('career') ) ? 0 : document.getElementById('header').clientHeight;
      window.scrollTo({
        top: rect + offset - gap,
        behavior: 'smooth',
      });
    });
  });
}

function handleScroll() {
  const scrollable = document.querySelector('.js-scrollable');
  scrollable.classList.add('is-scrolled');
  scrollable.removeEventListener('touchmove', handleScroll);
  scrollable.removeEventListener('scroll', handleScroll);
}
